const ATTRIBUTE_ORDER = ['Ширина', 'Дължина', 'Височина', 'Размер', 'Материал'];

const collator = new Intl.Collator('bg', { numeric: true, sensitivity: 'base' });

const attributeOrder = (first, second) => {
  const firstIndex = ATTRIBUTE_ORDER.indexOf(first);
  const secondIndex = ATTRIBUTE_ORDER.indexOf(second);
  const normalizedFirstIndex = firstIndex === -1 ? ATTRIBUTE_ORDER.length : firstIndex;
  const normalizedSecondIndex = secondIndex === -1 ? ATTRIBUTE_ORDER.length : secondIndex;
  return normalizedFirstIndex - normalizedSecondIndex || collator.compare(first, second);
};

const toVariant = (option) => ({
  ...option,
  attributeValues: Object.fromEntries(
    (option.attributes || [])
      .filter((attribute) => attribute?.label && attribute?.value !== undefined && attribute?.value !== null)
      .map((attribute) => [attribute.label, String(attribute.value)])
  )
});

export const groupProductOptions = (options = []) => {
  const groups = new Map();

  options.forEach((option) => {
    const key = String(option.productId ?? option.priceId);
    const group = groups.get(key) || {
      id: key,
      productName: option.productName,
      productCode: option.productCode,
      subcategoryId: option.subcategoryId,
      subcategoryName: option.subcategoryName,
      imageUrl: option.imageUrl,
      variants: []
    };
    group.variants.push(toVariant(option));
    groups.set(key, group);
  });

  return Array.from(groups.values())
    .map((group) => {
      const valuesByLabel = new Map();
      group.variants.forEach((variant) => {
        Object.entries(variant.attributeValues).forEach(([label, value]) => {
          const values = valuesByLabel.get(label) || new Set();
          values.add(value);
          valuesByLabel.set(label, values);
        });
      });

      return {
        ...group,
        attributes: Array.from(valuesByLabel.entries())
          .filter(([, values]) => values.size > 1)
          .map(([label, values]) => ({
            label,
            values: Array.from(values).sort(collator.compare)
          }))
          .sort((first, second) => attributeOrder(first.label, second.label))
      };
    })
    .sort(
      (first, second) =>
        collator.compare(first.productName || '', second.productName || '') ||
        collator.compare(first.productCode || '', second.productCode || '')
    );
};

export const findMatchingVariants = (group, selections = {}) =>
  group.variants.filter((variant) =>
    Object.entries(selections).every(
      ([label, value]) => value === '' || variant.attributeValues[label] === value
    )
  );

export const resolveProductVariant = (group, selections = {}) => {
  const allAttributesSelected = group.attributes.every((attribute) => selections[attribute.label]);
  const matches = findMatchingVariants(group, selections);
  return allAttributesSelected && matches.length === 1 ? matches[0] : null;
};
